import React from 'react';

import { Label as MobiusSBLabel } from '@simplybusiness/mobius-simplybusiness';

const Label = (props) => (
  <MobiusSBLabel
    margin={0}
    color="#111118"
    {...props} // eslint-disable-line react/jsx-props-no-spreading
  />
);

export default Label;
